var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { background: "#fff" } },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "line-height": "38px" },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              staticClass: "vct_text",
              attrs: { label: "我要评论", name: "first" }
            },
            [
              _c("div", { staticClass: "vc_wypl" }, [
                _c("div", { staticClass: "vcw_textarea" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.commentValue,
                        expression: "commentValue"
                      }
                    ],
                    attrs: {
                      placeholder: "我来说两句...(最多200字符)",
                      maxlength: "200",
                      id: "TextArea1"
                    },
                    domProps: { value: _vm.commentValue },
                    on: {
                      keyup: function($event) {
                        return _vm.checkLength()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.commentValue = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "vcw_btn" },
                  [
                    _c("p", { staticClass: "vcw_btn_num" }, [
                      _vm._v("您还可以输入："),
                      _c("span", { attrs: { id: "sy" } }, [
                        _vm._v(_vm._s(_vm.curr))
                      ]),
                      _vm._v("字")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content:
                            "请勿发表政治性言论，请勿谈论色情、暴力等内容的话题。严禁任何反动言论和宣传;",
                          placement: "top",
                          effect: "light"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.commentValue
                            },
                            on: { click: _vm.commitComment }
                          },
                          [_vm._v("发表评论")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vc_title" }, [
                _c("div", { staticClass: "vct_text" }, [
                  _vm._v("全部评论"),
                  _c("span", [_vm._v("（" + _vm._s(_vm.total) + "）")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vc_plList" },
                _vm._l(_vm.commentList, function(item) {
                  return _c("div", { staticClass: "vcpl" }, [
                    _c("div", { staticClass: "vcpl_pic" }, [
                      _c("img", { attrs: { src: item.userInfo.image } })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vcpl_info" }, [
                      _c("div", { staticClass: "vcpli_user" }, [
                        _c("span", { staticClass: "vcpli_user_name" }, [
                          _vm._v(_vm._s(item.userInfo.realName))
                        ]),
                        _c("span", { staticClass: "vcpli_user_time" }, [
                          _vm._v(_vm._s(item.createTime))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "vcpli_text" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(item.content) +
                            "\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.adminReplay != "",
                              expression: "item.adminReplay !=''"
                            }
                          ],
                          staticClass: "vcpli_disk"
                        },
                        _vm._l(item.adminReplay, function(itemRep) {
                          return _c("div", { staticClass: "vcdk" }, [
                            _c("div", { staticClass: "vcdk_pic" }, [
                              _c("img", {
                                attrs: { src: "/static/favicon.ico" }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "vcdk_info" }, [
                              _c("div", { staticClass: "vcdki_user" }, [
                                _c("span", { staticClass: "vcdki_user_name" }, [
                                  _vm._v("医博士官方人员")
                                ]),
                                _c("span", { staticClass: "vcdki_user_time" }, [
                                  _vm._v(_vm._s(itemRep.createTime))
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "vcpli_text" }, [
                                _vm._v(_vm._s(itemRep.content))
                              ])
                            ])
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vc_plPage" },
                [
                  _c("el-pagination", {
                    attrs: {
                      small: "",
                      layout: "prev, pager, next",
                      "current-page": _vm.currentPage,
                      "page-size": _vm.pageSize,
                      total: _vm.total
                    },
                    on: {
                      "current-change": _vm.handleCurrentChange,
                      "update:currentPage": function($event) {
                        _vm.currentPage = $event
                      },
                      "update:current-page": function($event) {
                        _vm.currentPage = $event
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("el-tab-pane", { attrs: { label: "记录笔记", name: "second" } }, [
            _c("div", { staticClass: "vc_wypl" }, [
              _c("div", { staticClass: "vcw_textarea" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.commentNoteValue,
                      expression: "commentNoteValue"
                    }
                  ],
                  attrs: {
                    placeholder: "我来说两句...(最多500字符)",
                    maxlength: "500",
                    id: "TextArea2"
                  },
                  domProps: { value: _vm.commentNoteValue },
                  on: {
                    keyup: function($event) {
                      return _vm.checkNoteLength()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.commentNoteValue = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vcw_btn" },
                [
                  _c("p", { staticClass: "vcw_btn_num" }, [
                    _vm._v("您还可以输入："),
                    _c("span", { attrs: { id: "sy" } }, [
                      _vm._v(_vm._s(_vm.currNote))
                    ]),
                    _vm._v("字")
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content:
                          "请勿发表政治性言论，请勿谈论色情、暴力等内容的话题。严禁任何反动言论和宣传;",
                        placement: "top",
                        effect: "light"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.commentNoteValue
                          },
                          on: { click: _vm.commitCommentNote }
                        },
                        [_vm._v("保存笔记")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vc_title" }, [
              _c("div", { staticClass: "vct_text" }, [
                _vm._v("全部笔记"),
                _c("span", [_vm._v("（" + _vm._s(_vm.totalNote) + "）")])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "vc_plList" },
              _vm._l(_vm.noteList, function(item) {
                return _c("div", { staticClass: "vcpl" }, [
                  _c("div", { staticClass: "vcpl_info" }, [
                    _c("div", { staticClass: "vcpli_user" }, [
                      _c("span", { staticClass: "vcpli_user_time" }, [
                        _vm._v(_vm._s(item.createTime))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "vcpli_text" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(item.content) +
                          "\n            "
                      )
                    ])
                  ])
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "vc_plPage" },
              [
                _c("el-pagination", {
                  attrs: {
                    small: "",
                    layout: "prev, pager, next",
                    "current-page": _vm.currentPageNote,
                    "page-size": _vm.pageSizeNote,
                    total: _vm.totalNote
                  },
                  on: {
                    "current-change": _vm.handleNoteCurrentChange,
                    "update:currentPage": function($event) {
                      _vm.currentPageNote = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPageNote = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("loginLayer", {
        attrs: { visible: _vm.loginVisible },
        on: {
          "update:visible": function($event) {
            _vm.loginVisible = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-133ed8df", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133ed8df","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment.vue
// module id = null
// module chunks = 